export const HPSMART = 'hpsmart';
export const PRINTER = 'printer';
export const EASY_START = 'hpeasystart';
export const SURE_SUPPLY = 'hpsuresupply';
export const PSA = 'psa';

export const IOS = 'ios';
export const ANDROID = 'android'
export const BACK = 'Back'
export const SAVE = 'Save'

export const requiredBasicWelcome = 'bizops.device.basicfunct.-.printer.print.npf';
export const requiredBasicPrinterWelcomeData = 'bizops.device.basicfunct.-.hpsmart.print.npf';

export const piplDataTransfer = 'bizops.device.telemetry.unmanaged.transfer';

// V1 purpose id's

export const requiredBasicPrinter = 'bizops.device.basicfunct.-.printer-v1.print.npf';
export const printerAnalytics = 'prodsupport.device.telemetry.-.printer-v1.print';
export const printerAdvertizing = 'advertising.device.marketing.-.printer-v1.print';
export const printerPersonlization = 'personalization.device.personalization.-.printer-v1.print';

export const requiredBasicHPSmartApp = 'bizops.device.basicfunct.-.hpsmart-v1.print.npf';
export const hpsmartAppAnalytics = 'prodsupport.device.telemetry.-.hpsmart-v1.print.google';
export const hpsmartAppAdvertizing = 'advertising.device.marketing.-.hpsmart-v1.print';
export const hpsmartAppPersonlization = 'personalization.device.personalization.-.hpsmart-v1.print';

export const easyStartProOperationID = 'bizops.device.basicfunct.-.hpeasystart.print.npf';
export const easyStartProUsageID = 'prodsupport.device.telemetry.-.hpeasystartpro.print';
export const easyStartBasicID = 'bizops.device.basicfunct.-.hpeasystart.print.npf';
export const easyStartUsageID = 'prodsupport.device.telemetry.-.hpeasystart.print.google';

export const easyStartBasicModifyConsentID = 'bizops.device.basicfunct.-.hpapp.-.npf';
export const easyStartUsageModifyConsentID = 'prodsupport.device.telemetry.-.hpapp';

export const requiredBasicHPApp = 'bizops.device.basicfunct.-.hpapp.-.npf';
export const hpsmartWjaAppAnalytics = 'prodsupport.device.telemetry.-.-.print';

export const sureSupplyAnalytics = 'prodsupport.device.telemetry.-.hpsuresupply.print';

//PSA ids
export const psaBasic = requiredBasicHPApp;
export const psaProduct = 'prodsupport.device.telemetry.-.hpapp';
export const psaAI = 'khkwltg592jiqeumumnlv7j6ya8mot5wewbeopp4';

export const DEFAULT_USER_CONSENTS = {
  'prodsupport.device.telemetry.-.hpsmart-v1.print.google': false,
  'advertising.device.marketing.-.hpsmart-v1.print': false,
  'personalization.device.personalization.-.hpsmart-v1.print': false
};

export const DEFAULT_PRINTER_CONSENTS = {
  'prodsupport.device.telemetry.-.printer-v1.print': false,
  'advertising.device.marketing.-.printer-v1.print': false,
  'personalization.device.personalization.-.printer-v1.print': false
};

export const DEFAULT_USER_CONSENTS_EASY_START_PRO = {
  'prodsupport.device.telemetry.-.hpeasystartpro.print': false
};

export const DEFAULT_USER_CONSENTS_EASY_START = {
  'prodsupport.device.telemetry.-.hpeasystart.print.google': false
};
export const DEFAULT_USER_CONSENTS_EASY_START_MODIFY_CONSENT = {
  'prodsupport.device.telemetry.-.hpeasystart.print.google': false
};

export const DEFAULT_WJA_CONSENTS = {
  'prodsupport.device.telemetry.-.-.print': false
};

export const DEFAULT_WELCOME_CONSENTS_SURE_SUPPLY = {
  'prodsupport.device.telemetry.-.hpsuresupply.print': false
};
